import { useContext } from 'react';
import { Context } from './context';
export function useMobileNavigation() {
    return useContext(Context);
}
